import axios, { AxiosError, AxiosResponse } from 'axios'
import { ICommonQuery } from '@Models/common.model'
import { MUserProfile } from '@Models/client/profile.model'
import * as Redux from 'redux'
import { MInvoice, MUserPayment } from '@Models/client/my-account.model'
import SharedActions from '@SharedActions/loading.action'
import { APIServices } from '@Services/api.service'
import { ToastServices } from '@Services/toast.service'
import { ClientActionTypes } from '../client.action-types'

const INVOICES = `admin/invoices`
const PAYMENTS = `admin/payments`

const createInvoice = (body: any) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setClientLoading(true) as any)
        APIServices.axiosConfig()
        return new Promise((resolve, reject) => {
            axios
                .post(INVOICES, body)
                .then((response: AxiosResponse) => {
                    ToastServices.success('Invoice created')
                    dispatch(SharedActions.setClientLoading(false) as any)
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    dispatch(SharedActions.setClientLoading(false) as any)
                    reject(errors)
                })
        })
    }
}

const getInvoices = (params?: ICommonQuery) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setClientLoading(true) as any)
        APIServices.axiosConfig()
        axios
            .get(INVOICES, { params: { isDetail: true, ...params } })
            .then((response: AxiosResponse) => {
                const { data, metadata } = response?.data
                const formattedData = data?.map(
                    (item: any) => new MInvoice(item)
                )
                const payload = {
                    invoices: formattedData,
                    invoiceMetaData: metadata,
                }
                dispatch(SharedActions.setClientLoading(false) as any)
                dispatch({ type: ClientActionTypes.GET_INVOICES, payload })
            })
            .catch((errors: AxiosError) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
                dispatch(SharedActions.setClientLoading(false) as any)
            })
    }
}

const getPayments = (params?: ICommonQuery) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setClientLoading(true) as any)
        APIServices.axiosConfig()
        axios
            .get(PAYMENTS, { params })
            .then((response: AxiosResponse) => {
                const { data, metadata } = response?.data
                const formattedData = data?.map(
                    (item: any) => new MUserPayment(item)
                )
                const payload = {
                    payments: formattedData,
                    paymentsMetaData: metadata,
                }
                dispatch(SharedActions.setClientLoading(false) as any)
                dispatch({ type: ClientActionTypes.GET_PAYMENTS, payload })
            })
            .catch((errors: AxiosError) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
                dispatch(SharedActions.setClientLoading(false) as any)
            })
    }
}

const ClientMyAccountActions = {
    createInvoice,
    getInvoices,
    getPayments,
}

export default ClientMyAccountActions
